import React from "react";
export const money = (value) =>
  value === "" || value == null
    ? "-"
    : Number(value).toLocaleString("en-GB", {
        style: "currency",
        currency: "GBP",
      });
export const refundableLabel = (value) =>
  value == null ? "-" : value ? "Yes" : "No";
export function TierTable({ rows = [], showHeader = true, annual = false, rateOnly = false }) {
  return rows.length ? (
    <table className="fee-tiers">
      <colgroup><col style={{ width: "20%" }} /><col style={{ width: "40%" }} /><col style={{ width: "40%" }} /></colgroup>
      {showHeader && (
        <thead>
          <tr>
            <th>{annual ? "Rate (% p.a.)" : "Rate (%)"}</th>
            <th>From</th>
            <th>To</th>
          </tr>
        </thead>
      )}
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <td>{r.rate}%</td>
            <td>{rateOnly ? "" : money(r.from)}</td>
            <td>{rateOnly ? "" : money(r.to)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <span>-</span>
  );
}
export default function FeeStructureDetails({ value }) {
  return (
    <div className="fee-details">
      <dl>
        <dt>Version</dt>
        <dd>{value.version}</dd>
        <dt>Date</dt>
        <dd>{value.date || "-"}</dd>
        <dt>Fixed fee</dt>
        <dd>{money(value.fixedFee)}</dd>
        <dt>Refundable</dt>
        <dd>{refundableLabel(value.refundable)}</dd>
      </dl>
      {value.category === "financial-planning" ? (
        <>
          <h4>Progressive Tiers</h4>
          <TierTable rows={value.tiers} />
          <h4>Ongoing Fees</h4>
          {value.ongoingType === "tiered" ? (
            <TierTable rows={value.ongoingTiers} annual />
          ) : (
            <p>
              {value.ongoingRate === "" ? "-" : `${value.ongoingRate}%`}
            </p>
          )}
        </>
      ) : (
        <>
          <h4>Fee With Any Variations</h4>
          <p>{value.variations || "-"}</p>
        </>
      )}
      {!!value.charges?.length && (
        <>
          <h4>Additional Charges</h4>
          {value.charges.map((r, i) => (
            <p key={i}>
              {r.name}: {money(r.amount)}
            </p>
          ))}
        </>
      )}
      <h4>Fee notes</h4>
      <p>{value.notes || "-"}</p>
    </div>
  );
}
